<template>
    <RatesTableFormCommon :hideResidenceType="store?.state?.global?.page?.hide_residence_type_input" />
</template>

<script>
import { useStore } from 'vuex'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
}
</script>
